App.Models.detection = class detection extends PF.Model {

    init() {
        super.init();

        this.calc('processText', ['process'], (p) => p === true ? "Обработано" : "В обработке");
        this.calc('hasScreenViewText', ['has_screen_view'], (p) => p === true ? "Есть просмотр экрана" : "Нет просмотра экрана");
        this.calc('trackFormatted', ['track'], (d) => JSON.stringify(d, undefined, 2));
        this.calc('startFormatted', ['start'], (d) => Util.toLocalDt(d, "dd.MM.yyyy HH:mm:ss.u"));
        this.calc('finishFormatted', ['finish'], (d) => Util.toLocalDt(d, "dd.MM.yyyy HH:mm:ss.u"));
        this.calc('emotionPercent', ['emotion_percent'], (d) => d ? (d * 100).toFixed(2) + "%" : "");

        this.calc('similarityPercent', ['similarity'], (d) => d ? (d * 100).toFixed(2) + "%" : "");
    }


};